<script>
import Config from '@/config';
import Main from '@/mixins/main';
import Size from '@/mixins/size';
import {formatDistance} from '@/libs/util';
import {mapActions, mapGetters} from 'vuex';
import {getAds, getNearbyStations} from '@/api';
import {location, drivingRoute} from '@/libs/map';
import {Icon, Image, PullRefresh, Search, Sticky, Tag, Swipe, SwipeItem} from 'vant';

export default {
  mixins: [
    Main,
    Size,
  ],
  components: {
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      ads: null,
      keyword: null,
      orderByOption: 0,
      allStations: [],

      refreshing: false
    };
  },
  computed: {
    ...mapGetters([
      'centerPoint'
    ]),
    stations() {
      if (this.orderByOption === 0) {
        return this.allStations.sort((a, b) => a.distance * 7 + (a.currentElectricRate + a.currentServiceRate) * 3 - b.distance * 7 - (b.currentElectricRate + b.currentServiceRate) * 3);
      } else if (this.orderByOption === 1) {
        return this.allStations.sort((a, b) => a.distance - b.distance);
      } else if (this.orderByOption === 2) {
        return this.allStations.sort((a, b) => a.currentElectricRate + a.currentServiceRate - b.currentElectricRate - b.currentServiceRate);
      }
      return this.allStations;
    }
  },
  watch: {
    centerPoint() {
      this.loadData();
    },
  },
  mounted() {
    window.document.title = '速电通欢迎您！';

    this.location();

    this.refresh();
  },
  methods: {
    ...mapActions([
      'setCenterPoint'
    ]),
    refresh() {
      this.loadData();

      getAds().then(response => {
        if (response.data.code === Config.successCode) {
          this.ads = response.data.body;
        }
      });
    },
    location() {
      location((longitude, latitude) => {
        this.setCenterPoint({longitude: longitude, latitude: latitude});
      });
    },
    loadData() {
      getNearbyStations({longitude: this.centerPoint.longitude, latitude: this.centerPoint.latitude, keywords: this.keyword}).then(response => {
        if (response.data.code === Config.successCode) {
          this.allStations = response.data.body.map(value => {
            value.distanceShow = formatDistance(value.distance);

            drivingRoute(this.centerPoint, value, (distance, duration) => {
              value.distanceShow = distance;
              value.duration = duration;
            });

            let currentRate = value.timeBuckets.find(element => element.isCurrent);
            value.currentServiceRate = currentRate.serviceRate;
            value.currentElectricRate = currentRate.electricRate;
            value.priceRate = (currentRate.serviceRate + currentRate.electricRate).toFixed(2);
            return value;
          });
        }
      }).finally(() => {
        this.refreshing = false;
      });
    },
    keywordChange() {
      this.loadData();
    },
    choseOption(value) {
      this.orderByOption = value;
    },
    adClick(ad) {
      if (!ad.goUrl) {
        return;
      }
      window.location.href = ad.goUrl;
    },
    toStation(stationCode) {
      this.$router.push({name: 'station', params: {stationCode}});
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" :class="ads ? 'has-ad' : ''" :style="{height: (height - 64) + 'px'}" id="stations">
    <van-search v-model="keyword" @search="keywordChange" @clear="keywordChange" clearable placeholder="请输入充电站名称" left-icon="search" shape="round" class="search"/>
    <van-swipe v-if="ads" class="ad-position" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(ad, index) in ads" :key="index" class="ad" @click="adClick">
        <van-image radius="8" width="100%" height="136" lazy-load :src="ad.imgUrl"/>
      </van-swipe-item>
    </van-swipe>
    <van-sticky>
      <div class="order-by">
        <van-tag :color="orderByOption === 0 ? '#009251' : 'white'" :text-color="orderByOption === 0 ? 'white':'#666666'" :round="orderByOption === 0" @click="choseOption(0)" class="tag">综合排序</van-tag>
        <van-tag :color="orderByOption === 1 ? '#009251' : 'white'" :text-color="orderByOption === 1 ? 'white':'#666666'" :round="orderByOption === 1" @click="choseOption(1)" class="tag">离我最近</van-tag>
        <van-tag :color="orderByOption === 2 ? '#009251' : 'white'" :text-color="orderByOption === 2 ? 'white':'#666666'" :round="orderByOption === 2" @click="choseOption(2)" class="tag">价格最低</van-tag>
      </div>
    </van-sticky>
    <div class="stations">
      <div class="station" v-for="(station, i) in stations" :key="i" @click="toStation(station.code)">
        <div class="icon">
          <van-icon name="location" color="#009251"></van-icon>
        </div>
        <div class="info">
          <div class="title">{{ station.name }}</div>
          <div class="price">
            <div>{{ station.priceRate }}</div>
            <div class="currency">元/度</div>
          </div>
          <div class="guns">
            <div class="idle-num">{{ station.idleGunNum }}</div>
            <div class="word">空闲/{{ station.gunNum }}</div>
            <div class="type">快</div>
          </div>
          <div class="tags">
            <van-tag plain v-for="(tag, k) in station.tags" :key="k" class="tag">{{ tag }}</van-tag>
          </div>
        </div>
        <div class="h-split-line"></div>
        <div class="location" @click.stop="navigation(station.longitude, station.latitude)">
          <div class="distance">{{ station.distanceShow }}</div>
          <div class="duration">{{ station.duration }}</div>
          <div class="gps" @click="navigation(centerPoint, station)">导航</div>
        </div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#stations {
  overflow-y: auto;
  background-color: #F6F9F8;
}

#stations.has-ad .search,
#stations .ad-position {
  background-color: #009251;
}

#stations .ad {
  background-color: white;
  padding: 12px 12px 0 12px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

#stations .order-by {
  display: flex;
  padding: 12px 24px;
  align-items: center;
  background-color: white;
  justify-content: space-between;
}

#stations .order-by .tag {
  font-size: 16px;
  padding: 4px 12px;
}

#stations .stations {
  padding: 8px;
}

#stations .stations .station {
  display: flex;
  border-radius: 8px;
  background-color: white;
  padding: 16px 0 16px 12px;
  justify-content: space-between;
}

#stations .stations .station + .station {
  margin-top: 8px;
}

#stations .stations .station .icon {
  height: 24px;
  display: flex;
  align-items: center;
}

#stations .stations .station .info {
  flex: 2;
  margin-left: 8px;
}

#stations .stations .station .info .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#stations .stations .station .info .price {
  color: #009251;
  font-size: 18px;
  margin-top: 8px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

#stations .stations .station .info .price .currency {
  color: #999999;
  font-size: 14px;
  font-weight: normal;
}

#stations .stations .station .info .guns {
  display: flex;
  color: #999999;
  font-size: 14px;
  margin-top: 8px;
  align-items: center;
}

#stations .stations .station .info .guns .idle-num {
  color: #009251;
  font-weight: bold;
}

#stations .stations .station .info .guns .word {
  margin-left: 1px;
}

#stations .stations .station .info .guns .type {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  font-size: 13px;
  margin-left: 4px;
  text-align: center;
  color: rgba(253, 93, 15, 1);
  border-radius: 8px 8px 8px 0;
  background-color: rgba(253, 93, 15, 0.1);;
}

#stations .stations .station .info .tags {
  margin-top: 8px;
}

#stations .stations .station .info .tags .tag {
  color: #C2C2C2;
  font-size: 11px;
}

#stations .stations .station .info .tags .tag + .tag {
  margin-left: 4px;
}

#stations .stations .station .h-split-line {
  width: 1px;
  height: 60px;
  margin: 24px 4px;
  background-color: #BFBFBF;
}

#stations .stations .station .location {
  width: 104px;
  display: flex;
  margin: 24px 0;
  color: #009251;
  font-size: 18px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

#stations .stations .station .duration {
  color: gray;
  height: 14px;
  font-size: 10px;
  padding: 4px 0 6px 0;
}

#stations .stations .station .location .gps {
  width: 48px;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  border-radius: 12px;
  padding: 2px 8px 4px 8px;
  background-color: #009251;
  box-shadow: 0 2px 5px 0 rgba(0, 146, 81, 0.44);
}

#stations .stations .station .location .gps a {
  color: #ffffff;
}
</style>
